import { createAction, props } from '@ngrx/store'
import { EventTicketEntity, EventTicketProfilePayload } from './event-tickets.models'
import { HttpErrorResponse } from '@angular/common/http'
import { AuthenticationEntity } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'

// re-export base event tickets actions from shared lib
export * from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.actions'

export const initEventTicketsPage = createAction(
  '[EventTickets/Page] Init Event Tickets Page',
  (uuid: string = '', action: string = '', token: string = '') => ({
    uuid,
    action,
    token,
  }),
)

export const handleEventTicketInvite = createAction(
  '[EventTickets/Page] Handle Event Ticket Invite',
  props<{ uuid: string; action: string; token: string }>(),
)

export const handleEventTicketInviteCancel = createAction('[EventTickets/Page] Handle Event Ticket Invite Cancel')

export const handleInvalidEventTicketToken = createAction('[EventTickets/Page] Handle Invalid Event Ticket Token')

export const handleInvalidEventTicketInvite = createAction('[EventTickets/Page] Handle Invalid Event Ticket Invite')

export const handleEventTicketInviteVolunteer = createAction('[EventTickets/Page] Handle Event Ticket Invite Volunteer')

export const handleEventTicketSocialLogin = createAction(
  '[EventTickets/Page] Handle Event Ticket Social Login',
  props<{ token: string }>(),
)

export const updateSelectedEventTicket = createAction(
  '[EventTickets/Page] Update Selected Event Ticket',
  props<{ uuid: string }>(),
)

export const acceptEventTicketInvite = createAction(
  '[EventTickets/API] Accept Event Ticket Invite',
  props<{
    token: string
    profile?: EventTicketProfilePayload
    isAcceptOnBehalf?: boolean
    isStepper?: boolean
    isVerificationRequired?: boolean
  }>(),
)

export const acceptEventTicketInviteSuccess = createAction(
  '[EventTickets/API] Accept Event Ticket Invite Success',
  props<{
    eventTicket: EventTicketEntity
    authentication: AuthenticationEntity | null
    isStepper?: boolean
    isVerificationRequired?: boolean
  }>(),
)

export const acceptEventTicketInviteComplete = createAction('[EventTickets/API] Accept Event Ticket Invite Complete')

export const verifySuccess = createAction(
  '[EventTickets/API] Verify Success',
  (isStepper = true, isVerificationRequired = false) => ({ isStepper, isVerificationRequired }),
)

export const acceptEventTicketInviteFailure = createAction(
  '[EventTickets/API] Accept Event Ticket Invite Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const declineEventTicket = createAction('[EventTickets/Page] Decline Event Ticket', props<{ token?: string }>())

export const declineEventTicketSuccess = createAction(
  '[EventTickets/API] Decline Event Ticket Success',
  props<{ token?: string }>(),
)

export const declineEventTicketFailure = createAction(
  '[EventTickets/API] Decline Event Ticket Failure',
  props<{ error: HttpErrorResponse }>(),
)

// DIALOG ACTIONS

export const openEventTicketMismatchDialog = createAction('[EventTickets/Page] Open Event Ticket Mismatch Dialog')

export const openEventTicketAcceptDialog = createAction('[EventTickets/Page] Open Event Ticket Accept Dialog')

export const openEventTicketDeclineDialog = createAction('[EventTickets/Page] Open Event Ticket Decline Dialog')

export const openEventTicketQuestionsDialog = createAction('[EventTickets/Page] Open Event Ticket Questions Dialog')

export const openEventTicketDialog = createAction(
  '[EventTickets/Page] Open Event Ticket Dialog',
  props<{ uuid: string }>(),
)
